export enum AlertType {
    paymentExpiring = 'Payment Expiring',
    paymentError = 'Payment Error',
    benefitReview = 'Benefit Review',
    newBenefits = 'New Benefits',
    passwordExpiring = 'Password Expiring',
    welcome = 'Welcome',
    products = 'Products',
    paymentUpdated = 'Payment Updated',
    enrollment = 'Enrollment',
    lifeEventRequest = 'Life Event Request'

}